import {IPaginationQuery} from "../types/types";

class PaginationQueryAdapter implements IPaginationQuery {
  pageNumber: number;
  pageSize: number;
  sortDirection: 'ASC' | 'DESC';

  constructor(page_number: number = 0, page_size: number = 10, direction: 'ASC' | 'DESC' = 'DESC') {
    this.pageNumber = page_number;
    this.pageSize = page_size;
    this.sortDirection = direction;
  }
}



export  default PaginationQueryAdapter;

